"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Keycloak
const keycloak_js_1 = __importDefault(require("keycloak-js"));
// Local instance
let kInstance = null;
let waitingKcInit;
const MAX_RETRY = 5;
let currentFailInit = 0;
exports.initKeycloak = (keycloakConfig, initOptions) => __awaiter(void 0, void 0, void 0, function* () {
    if (currentFailInit >= MAX_RETRY) {
        throw Error('Keycloak init fail after max retry');
    }
    try {
        if (kInstance && !waitingKcInit) {
            return kInstance;
        }
        else if (!waitingKcInit) {
            const keycloakInstance = keycloak_js_1.default(keycloakConfig);
            waitingKcInit = keycloakInstance.init(Object.assign({ onLoad: 'check-sso', checkLoginIframe: false }, initOptions));
            yield waitingKcInit;
            kInstance = keycloakInstance;
            waitingKcInit = undefined;
            return kInstance;
        }
        else if (waitingKcInit) {
            yield waitingKcInit;
            return kInstance;
        }
    }
    catch (error) {
        console.error(error);
        currentFailInit++;
        throw Error('Keycloak init fail');
    }
});
//# sourceMappingURL=keycloak.service.js.map